import { SubMenuList } from '../sub-menu-list';

export class CustomFilterButton extends SubMenuList {
  name = 'custom-filter';
}